export default {
  common: {
    or: 'OR',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    tagline: 'Professional video management platform',
    rightsReserved: 'All rights reserved'
  },
  login: {
    title: 'Sign In',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    submit: 'Sign In',
    google: 'Sign in with Google',
    noAccount: "Don't have an account?",
    register: 'Sign up',
    emailVerified: 'Email verified successfully! You can now sign in.'
  },
  register: {
    title: 'Create Account',
    name: 'Full Name',
    email: 'Email',
    password: 'Password',
    passwordConfirm: 'Confirm Password',
    terms: {
      accept: 'I agree to the',
      link: 'Terms of Service'
    },
    submit: 'Create Account',
    google: 'Sign up with Google',
    hasAccount: 'Already have an account?',
    login: 'Sign in'
  },
  forgotPassword: {
    title: 'Forgot Password',
    description: 'Enter your email address and we will send you a code to reset your password.',
    email: 'Email',
    submit: 'Send Reset Code',
    success: {
      title: 'Email Sent',
      message: 'We have sent a password reset code to {email}'
    },
    backToLogin: 'Back to Sign In',
    remember: 'Remember your password?',
    login: 'Sign in',
    enterCode: 'Enter Reset Code'
  },
  resetPassword: {
    title: 'Reset Password',
    description: 'Enter your new password below.',
    descriptionWithCode: 'Enter the 6-digit code sent to {email} and your new password.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    submit: 'Reset Password',
    success: {
      title: 'Password Reset',
      message: 'Your password has been successfully reset.'
    },
    login: 'Sign In',
    invalidToken: 'Invalid or expired reset link?',
    invalidCode: 'Invalid or expired reset code?',
    requestNew: 'Request a new one',
    codeLabel: 'Enter reset code'
  },
  emailVerification: {
    title: 'Verify Your Email',
    description: 'We\'ve sent a 6-digit verification code to {email}',
    verify: 'Verify Email',
    noCode: 'Didn\'t receive the code?',
    resend: 'Resend Code',
    resendIn: 'Resend in {seconds}s',
    codeSent: 'Verification code sent!',
    success: 'Email verified successfully!',
    successAutoLogin: 'Email verified successfully! Logging you in...',
    backToLogin: 'Back to Login',
    changeEmail: 'Change Email',
    otpLabel: 'Enter verification code'
  },
  organizationSetup: {
    title: 'Set Up Your Organization',
    description: 'Create your organization to start managing your video content',
    organizationName: 'Organization Name',
    organizationNamePlaceholder: 'My Company',
    organizationSlug: 'Organization URL',
    organizationSlugPlaceholder: 'my-company',
    slugHint: 'Your organization will be accessible at: videas.app/{slug}',
    submit: 'Create Organization',
    info: 'You can invite team members and configure settings after creating your organization.',
    success: 'Organization created successfully!'
  },
  validation: {
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email',
    passwordRequired: 'Password is required',
    passwordMin: 'Password must be at least {min} characters',
    passwordMinLength: 'At least {min} characters',
    passwordUppercase: 'At least one uppercase letter',
    passwordLowercase: 'At least one lowercase letter',
    passwordNumber: 'At least one number',
    passwordSpecial: 'At least one special character',
    passwordConfirmRequired: 'Please confirm your password',
    passwordMismatch: 'Passwords do not match',
    termsRequired: 'You must accept the terms of service',
    otpRequired: 'Verification code is required',
    otpLength: 'Code must be 6 digits',
    otpInvalid: 'Invalid verification code',
    codeRequired: 'Reset code is required',
    codeLength: 'Code must be 6 characters',
    strengthVeryWeak: 'Very Weak',
    strengthWeak: 'Weak',
    strengthFair: 'Fair',
    strengthGood: 'Good',
    strengthStrong: 'Strong',
    invalid: 'Invalid value',
    organizationNameRequired: 'Organization name is required',
    organizationNameMinLength: 'Organization name must be at least {min} characters',
    organizationSlugRequired: 'Organization URL is required',
    organizationSlugInvalid: 'URL can only contain lowercase letters, numbers, and hyphens',
    organizationSlugMinLength: 'URL must be at least {min} characters'
  },
  errors: {
    loginFailed: 'The email or password you entered is incorrect. Please try again.',
    googleFailed: 'Google sign in failed',
    registerFailed: 'Registration failed. Please try again.',
    forgotPasswordFailed: 'Failed to send reset email. Please try again.',
    resetPasswordFailed: 'Failed to reset password. Please try again.',
    invalidToken: 'Invalid or expired reset token',
    networkError: 'Network error. Please check your connection.',
    serverError: 'Server error. Please try again later.',
    verificationFailed: 'Invalid or expired verification code',
    resendFailed: 'Failed to resend code. Please try again.',
    organizationSetupFailed: 'Failed to create organization. Please try again.',
    missingEmailUid: 'Email verification link is invalid. Please register again.',
    missingEmail: 'Email address is required. Please start the password reset process again.'
  }
}